/**
 * 大六壬 · 课体
 *
 * 主课体由九宗门判定（sanChuan.ts 产出），本模块负责：
 * 1. 归一化课体名与归宗；
 * 2. 追加结构性附加课体：三传俱空、干支上神同位 / 相冲、三传入墓、三传见日支等。
 */
import { changSheng } from './constants';
/** 九宗门归宗 → 展示名 */
export const SCHOOL_LABEL = {
    贼克: '贼克',
    比用: '比用',
    涉害: '涉害',
    遥克: '遥克',
    昴星: '昴星',
    别责: '别责',
    八专: '八专',
    伏吟: '伏吟',
    返吟: '返吟',
};
/** 由三传与四课结构生成课体 */
export function buildKeTi(input) {
    const { san, chuan, dayGanIndex, dayZhiIndex, ganShangIndex, zhiShangIndex } = input;
    const extras = [...san.extras];
    // 三传俱空
    if (chuan.length === 3 && chuan.every((c) => c.kong))
        extras.push('三传俱空');
    // 干支上神同位（干支同气）
    if (ganShangIndex === zhiShangIndex)
        extras.push('干支上神同位');
    // 干支上神相冲
    if ((ganShangIndex + 6) % 12 === zhiShangIndex)
        extras.push('干支上神相冲');
    // 三传入墓（三传皆落于日干之墓库）
    if (chuan.length === 3 && chuan.every((c) => changSheng(dayGanIndex, c.zhiIndex) === '墓')) {
        extras.push('三传入墓');
    }
    // 三传见日支（事关自身）
    if (chuan.some((c) => c.zhiIndex === dayZhiIndex))
        extras.push('三传见日支');
    return {
        name: san.keTiName,
        school: san.school,
        reason: san.reason,
        extras: [...new Set(extras)],
    };
}
/** 主课体名（去掉括注，如「伏吟课（自任）」→「伏吟课」） */
export function keTiShortName(keTi) {
    return keTi.name.replace(/（.*）/, '');
}
/** 课体简述（列表 / 摘要展示用） */
export function keTiSummary(keTi) {
    return `${keTi.name}${keTi.extras.length > 0 ? ` · ${keTi.extras.join('、')}` : ''}`;
}
/** 三传地支串（如「巳午未」） */
export function chuanText(chuan) {
    return chuan.map((c) => c.zhi).join('');
}
//# sourceMappingURL=keti.js.map